import React from 'react';
import { SingleCommonType } from '../../types';
import { PerspectivePlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { perspectiveOptions } from '../../constants/perspective';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function PerspectiveSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="perspective_type"
      singlePlaceholder={PerspectivePlaceholder}
      options={perspectiveOptions}
      initValue="category"
      pointKey={FilterButtonPoint.perspective}
    />
  );
}
